import React from "react";
import { Container } from "../../../components";
import { Icon, Text, Heading } from "@telia/teddy";
import "./Receipt.less";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../models";
import { getEmployeeInfo, getRequestedPortinDate, isEsimSelected } from "../../state/selectors";
import TEXT from "../../text-consts";

const SubscriptionDetails: React.FC = () => {
    const portinDate = useSelector((state: RootState) => getRequestedPortinDate(state));
    const employee = useSelector((state: RootState) => getEmployeeInfo(state));
    const isEsim = useSelector((state: RootState) => isEsimSelected(state));
    return (
        <Container size="medium" className="onboardingb2b-confirmation" noMargin>
            <Icon name="check-circle" className="onboardingb2b-confirmation__check-icon" />
            <Heading mb="100" as="h2" variant="title-200">
                {"Registreringen er fullført"}
            </Heading>
            <Text mb="100">{TEXT.ONBOARDING_B2B.RECEIPT.CONFIRMATION}</Text>
            {isEsim && (
                <Text mb="100" data-di-mask>
                    {TEXT.ONBOARDING_B2B.RECEIPT.ESIM(employee?.email)}
                </Text>
            )}
            {portinDate && (
                <Text mb="100">{TEXT.ONBOARDING_B2B.RECEIPT.PORTIN(new Date(portinDate).toLocaleString())}</Text>
            )}
        </Container>
    );
};

export default SubscriptionDetails;
